import React, {forwardRef} from "react";
import { Badge, Box, IconButton, Tooltip } from "@mui/material";
import { telemetryProps } from "shared-ui/src/instrumentation/gtm";
import ShoppingCartIcon from "../../../../../images/shopping-cart.svg?react";
import CaretDownIcon from "../../../../../images/caret-down.svg?react";

const SVG_STYLE = {
  width: "100%",
  height: "100%",
  fill: "currentColor",
  shapeRendering: "geometricPrecision",
  transform: "translateZ(0)",
  backfaceVisibility: "hidden",
  WebkitFontSmoothing: "antialiased",
} as const;

type CartButtonProps = {
  cartOpen: boolean;
  setCartOpen: (open: boolean) => void;
  count: number;
};

const CartButton = forwardRef<HTMLButtonElement, CartButtonProps>(
  ({ cartOpen, setCartOpen, count }, ref) => (
    <Tooltip title="Shopping Cart" enterDelay={500}>
      <Box sx={{ position: "relative" }}>
        <IconButton
          ref={ref}
          onClick={() => setCartOpen(!cartOpen)}
          aria-label="View Cart"
          {...telemetryProps({ name: "header_cart", section: "unified_header", label: "Cart" })}
          sx={{ p: 1.5 }}
        >
          <Badge
            badgeContent={count}
            showZero
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            sx={{
              "& .MuiBadge-badge": {
                backgroundColor: "background.paper",
                color: "currentColor",
                border: "1px solid",
                borderColor: "currentColor",
                zIndex: 1,
                minWidth: "16px",
                height: "16px",
                padding: "0 4px",
              },
            }}
          >
            <Box
              sx={{
                width: 24,
                height: 24,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "& svg": SVG_STYLE,
              }}
            >
              <ShoppingCartIcon />
            </Box>
          </Badge>
        </IconButton>
        {/* Small arrow indicator */}
        <Box
          sx={{
            position: "absolute",
            bottom: 14,
            right: -2,
            width: 16,
            height: 16,
            pointerEvents: "none",
            "& svg": SVG_STYLE,
          }}
        >
          <CaretDownIcon
            style={{ transform: cartOpen ? "rotate(180deg)" : "none" }}
          />
        </Box>
      </Box>
    </Tooltip>
  ),
);

export default CartButton;
